import React from "react";
import { motion } from "framer-motion";
import SEO from "../components/SEO";

export default function AboutPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="about-page">
      <SEO title="About 3T" description="3T is more than a clothing brand — it is a mindset. We create premium tank tops for people who move with purpose and refuse to live on autopilot." />
      <div className="max-w-[900px] mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">
            OUR STORY
          </p>
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl tracking-tight uppercase leading-[0.9]">
            ABOUT <span className="text-[#FFD700]">3T</span>
          </h1>
        </motion.div>

        {/* Intro */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="text-xl md:text-2xl text-white font-medium leading-relaxed mb-12"
        >
          3T is more than a clothing brand — it is a <span className="text-[#FFD700]">mindset</span>.
        </motion.p>

        {/* Content Blocks */}
        <div className="space-y-10">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed"
          >
            We create premium tank tops designed for people who move with purpose, think independently, and refuse to live on autopilot. Every piece is built to combine strong design, everyday comfort, and meaningful expression.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.35 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed"
          >
            At 3T, we believe what you wear should say something about who you are. That is why our collections are driven by bold, motivational, and thought-provoking messages — created to inspire confidence, discipline, and individuality.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.45 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed"
          >
            Born from the idea that fashion can carry meaning, 3T stands for strength, identity, and intention. We are here for those who want more than just style. We are here for those who want to wear a message, represent a mindset, and live with direction.
          </motion.p>

          {/* Closing Statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.55 }}
            className="border-l-4 border-[#FFD700] pl-6 py-4 mt-16"
          >
            <p className="font-heading text-xl md:text-2xl leading-snug tracking-wide uppercase">
              This is more than apparel.<br />
              This is a mindset.<br />
              This is <span className="text-[#FFD700]">3T</span>.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
